<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form__chang Form__chang_area Form__chang--member">
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                メールアドレス
              </div>
              <div class="Form__input_info _pd-l0">
                {{ userInfo.email_address }}
              </div>
            </div>
            <router-link
              to="/change/mail/"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                名前
              </div>
              <div class="Form__input_info _pd-l0">
                {{ userInfo.full_name }}
              </div>
            </div>
            <router-link
              to="/change/name/"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                電話番号
              </div>
              <div class="Form__input_info _pd-l0">
                {{ userInfo.phone }}
              </div>
            </div>
            <router-link
              to="/change/tell/"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                住所
              </div>
              <div v-if="userInfo.country==='海外'" class="Form__input_info _pd-l0">
                <div v-show="userInfo.postal_code">
                  〒{{ userInfo.postal_code }}
                </div>
                {{ userInfo.address1 ? userInfo.address1 : '' }} {{ userInfo.address2 ? userInfo.address2 : '' }}
              </div>
              <div v-else-if="userInfo.postal_code || userInfo.address1" class="Form__input_info _pd-l0">
                <div>〒{{ userInfo.postal_code }}</div>
                {{ userInfo.prefecture ? userInfo.prefecture : '' }} {{ userInfo.address1 ? userInfo.address1 : '' }} {{ userInfo.address2 ? userInfo.address2 : '' }}
              </div>
            </div>
            <router-link
              to="/change/address/"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                パスワード
              </div>
              <div class="Form__input_info _pd-l0">
                ********
              </div>
            </div>
            <router-link
              to="/change/password"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div v-if="userInfo.payment_type == 'STRIPE' || userInfo.payment_type == null || userInfo.payment_type == '1'" class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                お支払い情報
              </div>
              <div v-if="userInfo.visa" class="Form__input_info _pd-l0">
                ********{{ userInfo.visa }}<br>
                有効期限：{{ userInfo.expiration_visa }}
              </div>
            </div>
            <button
              class="Btn__blue Btn__blue--xs _mg0"
              @click.prevent="changeVisa"
            >
              変更
            </button>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                メール配信設定
              </div>
              <div class="Form__input_info _pd-l0">
                {{ userInfo.is_received_mail_promotion ? '配信する' : '配信しない' }}
              </div>
            </div>
            <router-link
              to="/change/e-mail"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                プッシュ通知設定
              </div>
              <div v-if="notiSend" class="Form__input_info _pd-l0">
                通知する
              </div>
              <div v-if="notiUnSend" class="Form__input_info _pd-l0">
                通知しない
              </div>
              <div
                v-if="notiSend === false && notiUnSend === false && userInfo.is_received_favorite_class_notification === 0"
                class="Form__input_info _pd-l0"
              >
                お気に入りのクラス前日通知: 通知しない
              </div>
              <div
                v-if="notiSend === false && notiUnSend === false && userInfo.is_received_log_input_notification === 0"
                class="Form__input_info _pd-l0"
              >
                ログのリマインド: 通知しない
              </div>
              <div
                v-if="notiSend === false && notiUnSend === false && userInfo.is_received_information_notification === 0"
                class="Form__input_info _pd-l0"
              >
                INFORMATION: 通知しない
              </div>
            </div>
            <router-link
              to="/change/notification"
              class="Btn__blue Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
          <div class="Form__chang_box">
            <div class="Form__chang_box_l">
              <div class="Form__input_heda Form__input_heda--ft_b">
                料金プラン
              </div>
              <div v-if="pricePerMonth > 0" class="Form__input_info Form__chang_box_member _pd-l0">
                {{ pricePerMonth.toLocaleString('ja-JP') }}円 / 月{{ userInfo.plan.interval_count > 1 ? '（' + userInfo.plan.interval_count + 'ヶ月プラン）' : '' }}
              </div>
              <div v-else class="Form__input_info Form__chang_box_member _pd-l0">
                {{ userInfo.plan.name }}
              </div>
              <div class="Form__input_info Form__chang_box_member _pd-l0">
                {{ userInfo.coupon }}
              </div>
              <div class="Form__input_info Form__chang_box_free _pd-l0">
                無料会員
              </div>
            </div>
            <router-link
              to="/unsubscribe/"
              class="Btn__blue Form__chang_box_member_btn Btn__blue--xs _mg0"
            >
              退会する
            </router-link>
            <router-link
              to="/change/membership"
              class="Btn__blue Form__chang_box_free_btn Btn__blue--xs _mg0"
            >
              変更
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import moment from 'moment'

export default {
  name: 'Change',
  data() {
    return {
      userInfo: {
        email_address: '',
        full_name: '',
        first_name: '',
        last_name: '',
        phone: '',
        prefecture: '',
        address1: '',
        address2: '',
        postal_code: '',
        is_received_mail_promotion: false,
        visa: null,
        expiration_visa: null,
        payment_type: null,
        country: '',
        is_received_information_notification: 0,
        is_received_favorite_class_notification: 0,
        is_received_log_input_notification: 0,
        display_cstatus: '',
        subscription_id: null,
        stripe_id: null,
        plan: '',
        coupon: ''
      },
      notiSend: false,
      notiUnSend: false,
      user_has_subscription: false,
      price_id: process.env.VUE_APP_STRIPE_PRICE_ID
    }
  },
  computed: {
    pricePerMonth() {
      const plan = this.userInfo.plan
      let price = 0
      if (plan.price > 0 && plan.interval_count > 0) {
        price = plan.price / plan.interval_count
      }
      return price
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUserInfo()
      if (this.$route.query['visa'] === 'success') {
        await this.updateUserPaymentInfo()
      }
      if (this.$route.query['checkout'] === 'success') {
        await this.updateUserSubscription()
      }
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo.email_address = userInfoData.email
      this.userInfo.full_name = userInfoData.display_name
      this.userInfo.first_name = userInfoData.first_name
      this.userInfo.last_name = userInfoData.last_name
      this.userInfo.phone = userInfoData.phone
      this.userInfo.prefecture = userInfoData.prefecture
      this.userInfo.address1 = userInfoData.address1
      this.userInfo.address2 = userInfoData.address2
      this.userInfo.country = userInfoData.country
      this.userInfo.postal_code = userInfoData.postcode
      this.userInfo.payment_type = userInfoData.payment_type
      this.userInfo.is_received_mail_promotion = userInfoData.is_received_mail_promotion
      this.userInfo.visa = userInfoData.visa
      this.userInfo.expiration_visa = userInfoData.month_visa + '/' + userInfoData.year_visa
      this.userInfo.is_received_favorite_class_notification = userInfoData.is_received_favorite_class_notification
      this.userInfo.is_received_log_input_notification = userInfoData.is_received_log_input_notification
      this.userInfo.is_received_information_notification = userInfoData.is_received_information_notification
      this.userInfo.display_cstatus = userInfoData.display_cstatus
      this.userInfo.stripe_id = userInfoData.stripe_id
      this.userInfo.subscription_id = userInfoData.subscription_id
      this.userInfo.plan = userInfoData.master_product
      this.userInfo.coupon = userInfoData.coupon_name
      this.handleNotification(userInfoData)
      this.$store.dispatch('loading/updateLoading', false)
    },
    handleNotification(user) {
      if (user.is_received_favorite_class_notification === 1 &&
          user.is_received_log_input_notification === 1 &&
          user.is_received_information_notification === 1) {
        this.notiSend = true
      }
      if (user.is_received_favorite_class_notification === 0 &&
          user.is_received_log_input_notification === 0 &&
          user.is_received_information_notification === 0) {
        this.notiUnSend = true
      }
    },
    async changeVisa() {
      this.$store.dispatch('loading/updateLoading', true)
      if (this.userInfo.subscription_id) {
        const response = await authService.updateStripePayment()
        if (response.success) {
          location.href = response.data.url
        }
      } else {
        const data = {
          price_id: this.userInfo?.plan.product_id,
          path: this.$route.path.substring(1)
        }
        if (this.userInfo.stripe_id) {
          data.customer_id = this.userInfo.stripe_id
        } else {
          data.email = this.userInfo.email_address
        }
        const response = await authService.checkout(data)
        if (response.success) {
          location.href = response.data.url
        }
      }
    },
    async updateUserPaymentInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const sessionID = this.$route.query['session_id']
      const response = await authService.updateUserVisa({ sessionID: sessionID })
      if (response.success) {
        this.$router.push({ name: 'ChangeVisaThanks', query: { success: true }})
      } else {
        alert(response.message)
        this.$router.replace({ 'query': { success: false }})
        this.$store.dispatch('loading/updateLoading', false)
      }
    },
    async updateUserSubscription() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.verifyPayment({ sessionID: this.$route.query['session_id'], email: this.userInfo.email_address })
      if (response.success) {
        const data = {}
        data.stripe_id = response.customer_id
        data.month_visa = response.payment_method.card.exp_month
        data.year_visa = response.payment_method.card.exp_year
        data.visa = response.payment_method.card.last4
        data.payment_method_id = response.payment_method.id
        data.subscription_id = response.subscription.id
        data.approve_at = moment.unix(response.subscription.current_period_start).format('YYYY-MM-DD HH:mm:ss')
        data.next_payment_date = moment.unix(response.subscription.current_period_end).format('YYYY-MM-DD HH:mm:ss')
        data.created_stripe = moment.unix(response.subscription.created).format('YYYY-MM-DD HH:mm:ss')
        data.plan = response.subscription.status
        await authService.updateUserInfo({ subscription: data })
        this.$router.push({ name: 'ChangeVisaThanks', query: { success: true }})
      } else {
        alert(response.message)
        this.$router.replace({ 'query': { success: false }})
        this.$store.dispatch('loading/updateLoading', false)
      }
    }
  }
}
</script>
